import React, { Component } from 'react';
import Hero from '../modules/Hero/Hero';
import globals from '../globals';
import HelmetDefault from "../layout/HelmetDefault";
import Heading from "../elements/Heading";
import ResponsiveTable from "../elements/ResponsiveTable";
import Terms from "../modules/Terms";

class InboundServices extends Component {

    constructor(props) {
        super(props);

        this.state = {
            title: '',
            subTitle: '',
            leadCopy: [],
            seoTitle: '',
            seoDescription: '',
            dataReceived: false,
			plans1: {data: {headings: [], rows: []}},
			plans2: {data: {headings: [], rows: []}},
			plans3: {data: {headings: [], rows: []}},
			faqs: []
        };
    }

    componentDidMount() {
        this.getData();
    }

	componentWillUnmount() {
		globals.destroy(this.controller1);
		globals.destroy(this.controller2);
		globals.destroy(this.controller3);
	}

    getData() {
        fetch('/api/voip/inbound-services')
            .then(result => result.json())
            .then((result) => {
                this.setState(result);
                this.setDataReceived();
                globals.animatePageIn(this.container);
				this.controller1 = globals.genericAnimation(this.table1);
				this.controller2 = globals.genericAnimation(this.table2);
				this.controller3 = globals.genericAnimation(this.table3);
            });
    }

    setDataReceived() {
        this.setState({
            dataReceived: true
        });
    }

    render() {
        return (
            <div ref={(el) => this.container = el} style={{opacity: 0}} className="voip-inbound-services">
                <HelmetDefault {...this.state} />
                <Hero title={this.state.title} subTitle={this.state.subTitle} leadCopy={this.state.leadCopy} dataReceived={this.state.dataReceived} />
                <section className="table-container">
					<div className="inner">
						<div className="row" ref={el => this.table1 = el}>
							<div className="col-md-8 col-md-offset-2 col-xs-12">
								<Heading title={this.state.plans1.title} />
								<ResponsiveTable data={this.state.plans1.data} />
							</div>
						</div>
						<div className="row space" ref={el => this.table2 = el}>
							<div className="col-md-8 col-md-offset-2 col-xs-12">
								<Heading title={this.state.plans2.title} />
								<ResponsiveTable data={this.state.plans2.data} />
							</div>
						</div>
						<div className="row space two-column-table" ref={el => this.table3 = el}>
							<div className="col-md-8 col-md-offset-2 col-xs-12">
								<Heading title={this.state.plans3.title} />
								<ResponsiveTable data={this.state.plans3.data} />
							</div>
						</div>
					</div>
					<div className="bottom-wave-darkgreen" />
				</section>
                <Terms title="Frequently asked questions" data={this.state.faqs} />
            </div>
        );
    }

}

export default InboundServices;


// WEBPACK FOOTER //
// ./resources/assets/js/voip/InboundServices.js